import { Link } from '@tanstack/react-router';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Motivos de 403 do backend, em pt-BR (spec 003, CA-03). */
const MOTIVOS: Record<string, string> = {
  DOIS_FATORES_OBRIGATORIO: 'Ative a verificação em duas etapas para continuar.',
  ACESSO_BLOQUEADO: 'Seu acesso a esta academia está bloqueado.',
  SEM_EMPRESA_ATIVA: 'Você não está em nenhuma academia ativa.',
};

export function textoDoMotivo(motivo: string | undefined): string | undefined {
  return motivo === undefined ? undefined : MOTIVOS[motivo];
}

/**
 * Tela sem permissão: rota fora de `telasPermitidas` (CA-02) ou 403 da API (CA-03). Aparece no
 * lugar do conteúdo, com o menu ao lado.
 */
export function SemAcesso({ motivo }: { motivo?: string | undefined }) {
  const texto = textoDoMotivo(motivo);
  return (
    <div role="alert" className="flex flex-col items-center gap-3 px-4 py-12 text-center">
      <Lock className="size-10 text-muted-foreground" aria-hidden />
      <p className="font-medium">Você não tem acesso a esta tela.</p>
      {texto !== undefined && <p className="text-sm text-muted-foreground">{texto}</p>}
      {motivo === 'DOIS_FATORES_OBRIGATORIO' ? (
        <Button asChild>
          <Link to="/ativar-2fa">Ativar a verificação</Link>
        </Button>
      ) : (
        <Button asChild variant="outline">
          <Link to="/">Ir para o Início</Link>
        </Button>
      )}
    </div>
  );
}
